import axios from '../axios'
import i18n from '../i18n'
import configurations from '../configurations'
import { AES } from 'crypto-js'

const defaultData = {
  name: '',
  full_name: '',
  ic_num: '',
  phone: '',
  machine_id: 'A10'
}

const form = {
  namespaced: true,
  state: {
    data: defaultData,
    error: null,
    id: null,
    loading: false,
    rules: {
      full_name: 'required',
      password: 'required',
      ic_no: 'required',
      confirm_password: 'required|confirmed:password',
      email_address: 'required|email',
      phone: 'required',
      cash: 'required'
    }
  },
  getters: {
    isLoading: function (state, getters, rootState, rootGetters) {
      return state.loading
    }
  },
  mutations: {
    setError: function (state, payload = { error: null }) {
      state.error = payload.error
    },
    setId: function (state, payload = { id: '' }) {
      state.id = payload.id
    },
    setLoading: function (state, payload = { loading: false }) {
      state.loading = payload.loading
    },
    setData: function (state, payload = { data: defaultData }) {
      state.data = payload.data
    }
  },
  actions: {
    fetchData: async function (context, payload = {}) {
      context.commit('setLoading', { loading: true })
      try {
        const response = await axios.post(
          `${configurations.WORKER}/userInfo`,
          { email: context.state.id },
          { withCredentials: false }
        )
        context.commit('setData', { data: response.data })
        context.commit('setError', { error: null })
      } catch (error) {
        context.commit('setError', { error })
        throw error
      } finally {
        context.commit('setLoading', { loading: false })
      }
    },
    patchData: async function (context, payload = {}) {
      const data = Object.assign({}, context.state.data, payload)
      context.commit('setData', { data })
    },
    resetData: async function (context, payload = {}) {
      context.commit('setData', { data: defaultData })
    },
    sendEmail: async function (context, payload) {
      try {
        const body = {
          channel: 'email',
          recipient: payload.contact.replace(/\s/g, ''),
          message: payload.message,
          subject: 'no-reply: MDKGU e-Services Email Verification Code'
        }
        const key = configurations.AES_SECRET
        const ciphertext = AES.encrypt(JSON.stringify(body), key).toString()
        await axios.post('/api/notify', { message: btoa(ciphertext) }, {
          baseURL: 'https://sms.menggaris.com',
          withCredentials: false
        })
        this.dispatch('snackbar/setSnackBar', { color: 'success', message: i18n.t('email_sent'), visible: true })
      } catch (error) {
        context.commit('setError', { error })
        this.dispatch('snackbar/setSnackBar', {color: 'error', message: 'Failed to send email verification', visible: true})
      } finally {
        context.commit('setLoading', { loading: false })
      }
    },
    submitData: async function (context, payload = defaultData) {
      const data = JSON.parse(JSON.stringify(context.state.data))
      data.timestamp = new Date().toISOString()
      data.machine_id = 'A10'
      data.roles = ['user']
      delete data.confirm_password
      const apiUrl = context.state.id
        ? `/_users/_design/backend/_update/users/${context.state.id}`
        : '/_users/_design/backend/_update/users'
      context.commit('setLoading', { loading: true })
      try {
        let response = await axios.post(configurations.WORKER + `/query`, { url: btoa(apiUrl), payload: data })
        return response.data
      } catch (error) {
        context.commit('setError', { error })
        if (error.response.data && error.response.data.error.error.includes('conflict')) {
          this.dispatch('snackbar/setSnackBar', {
            color: 'error',
            message: i18n.t('email_already_exist'),
            visible: true
          })
          return { error: 'conflict' }
        } else {
          this.dispatch('snackbar/setSnackBar', {
            color: 'error',
            message: i18n.t('attempt_failed_please_try_again'),
            visible: true
          })
        }
      } finally {
        context.commit('setLoading', { loading: false })
      }
    },
    updateData: async function (context, payload = defaultData) {
      let data = Object.assign({}, context.state.data)
      data.machine_id = 'A11'

      context.commit('setLoading', { loading: true })
      try {
        let response = await axios.post(
          `${configurations.WORKER}/updateUser`,
          { data },
          { withCredentials: false }
        )
        if (response.data._id) {
          context.commit('setData', { data: response.data })
          context.commit('setError', { error: null })
          this.dispatch('snackbar/setSnackBar', {
            color: 'success',
            message: i18n.t('update_successful'),
            visible: true
          })
        }
        return response.data
      } catch (error) {
        context.commit('setError', { error })
        if (error.response.data.error === 'conflict') {
          this.dispatch('snackbar/setSnackBar', {
            color: 'error',
            message: i18n.t('data_no_changes'),
            visible: true
          })
        } else {
          this.dispatch('snackbar/setSnackBar', {
            color: 'error',
            message: error.response.data.reason,
            visible: true
          })
        }
        throw error
      } finally {
        context.commit('setLoading', { loading: false })
      }
    }
  }
}

export default form
